<template>
  <div
    class="d-flex-column justify-start align-start info_pack b-radius-9 gap-0"
  >
    <div
      class="d-flex-row flex-1 space-between cursor-pointer"
      @click="toggleInfo"
    >
      <div class="d-flex-row flex-5 justify-start">
        <label class="medium-xxl t-white cursor-pointer font-family-2">{{
          title
        }}</label>
      </div>
      <div class="d-flex-row flex-5 justify-end">
        <div class="chev_icon" :class="[isOpen && 'opened']">
          <ChevRight />
        </div>
      </div>
    </div>
    <div
      class="d-flex-column justify-start align-start info_pack_content gap-15"
      ref="infoContent"
    >
      <ul class="info_pack_list" v-if="type === 'info'" :class="[type]">
        <li
          v-for="info in infos"
          :key="info"
          class="regular-l t-white font-family-2"
          v-html="info"
        ></li>
      </ul>
      <ul class="info_pack_list" v-if="type === 'faq'">
        <li
          v-for="info in infos"
          :key="info"
          class="regular-l t-white font-family-2 faq_info"
        >
          <!-- <p class="f-w-600">
                        {{ info.question }}<br />
                        <br />
                        <span class="f-w-400">{{ info.answer }}</span>
                    </p> -->
          <div class="d-flex-column justify-start align-start gap-10">
            <h2 class="regular-l f-w-600">{{ info.question }}</h2>
            <p class="f-w-400">{{ info.answer }}</p>
          </div>
        </li>
      </ul>
      <ul class="info_pack_list" v-if="type === 'extra_option'">
        <li
          v-for="info in options"
          :key="info"
          class="regular-l t-white font-family-2 gap-5"
        >
          <span class="f-w-700 white-space-no">{{ info.title }}: </span>
          <span class="f-w-400">{{ info.description }}</span>
        </li>
      </ul>

      <ul class="info_pack_list" v-if="type === 'method'" :class="'info'">
        <li
          v-for="info in infos"
          :key="info"
          class="regular-l t-white font-family-2 method_detail"
        >
          <div v-html="info"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ChevRight from "../icons/ChevRight.vue";

export default {
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    title: {
      default: "",
    },
    infos: {
      default: [],
    },
    type: {
      default: "info",
    },
  },
  computed: {
    options() {
      return this.infos.filter((info) =>
        [
          "express",
          "main_storyline",
          "dragonriding_glyphs",
          "dragonflight_loremaster",
          "amirdrassil_heroic_run",
        ].includes(info.const_title)
      );
    },
  },
  components: {
    ChevRight,
  },
  methods: {
    toggleInfo() {
      this.isOpen = !this.isOpen;
      const element = this.$refs?.infoContent;
      if (element) {
        if (element.style.maxHeight) {
          element.style.maxHeight = null;
          element.style.marginTop = "0px";
          element.style.borderWidth = "0px";
          element.style.paddingTop = "0px";
        } else {
          element.style.marginTop = "15px";
          element.style.maxHeight = `${element.scrollHeight + 15}px`;
          element.style.borderWidth = "1px";
          element.style.paddingTop = "15px";
        }
      }
    },
  },
};
</script>

<style lang="scss">
.method_detail {
  p {
    .warning-alert {
      width: 10px;
      margin-right: 5px;
    }
    .warning-alert-min {
      width: 15px;
      margin-right: 5px;
    }
  }
}
.info_pack_list {
  li {
    a {
      display: inline-block;
      white-space: nowrap;
    }
  }
}
</style>
